import * as d3 from "d3";
import {
    colonAnnotation, contextMenu,
    createTooltip,
    generateDownloadData,
    make_y_gridlines,
    numberFormat,
    pieChart,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // axios.post(url, filterParam).then(res => {
        let data = resData

        //  var innerWidth = chart.width - chart.margin.left - chart.margin.right
        //  var innerHeight = chart.height - chart.margin.top - chart.margin.bottom
        var svg = d3.select(divId).select("svg").remove();
        var groupData = d3.nest().key((d) => {
            return d.dim1_name
        }).entries(data)
        console.log("Group data values", data, groupData, groupData[0].values.map(function (d) {
            return d.dim2_name;
        }))

        svg = d3.select(divId)
            .append('svg')
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

        var x1AxisLabel = d3.scaleBand().rangeRound([0, chart.width]).paddingInner(.01)
        var x2AxisLabel = d3.scaleBand()
        var y1AxisLabel = d3.scaleLinear().rangeRound([chart.height, 0])
        var load = groupData[0].values.map(function (d) {
            return d.dim2_name;
        });
        // var metric1ColorScale=d3.scaleLinear().domain([d3.min(load),d3.max(load)]).range(["#feb24c","#00441b"])
        var metric1ColorScale = d3.scaleOrdinal(pieChart);
        metric1ColorScale.domain(load)
        //Tooltips
        // should there be a class?
        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
         var y1tip= tooltip_class()

         y1tip.attr('class', 'd3-tip'+divId.id)
              .html(d =>
                  chart.x1MetricTooltip+ colonAnnotation + numberFormat(d.metric1) + "<br/>" +
                  chart.y1MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                  chart.x2MetricTooltip + colonAnnotation + d.dim2_name)
         svg.call(y1tip)*/

        const tooltip = createTooltip(divId);

        x1AxisLabel.domain(groupData.map(function (d) {
            return d.key;
        }))
        x2AxisLabel.domain(groupData[0].values.map(function (d) {
            return d.dim2_name;
        })).rangeRound([0, x1AxisLabel.bandwidth()])
        y1AxisLabel.domain([0, d3.max(groupData, function (key) {
            return d3.max(key.values, function (d) {
                return d.metric1;
            });
        })]).nice()

        svg.append('g')
            .attr('class', 'axis-bottom')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(d3.axisBottom(x1AxisLabel))
            .selectAll("text")
            .style("font-size", axisLabelFontSize)

        svg.append('text')
            .attr('x', (chart.width /2.2))
            .attr('y', chart.height + 50)
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.x1AxisDisplayName)

        svg.append("g")
            .attr("class", "y axis")
            .call(d3.axisLeft(y1AxisLabel).tickFormat(numberFormat))
            .style("font-size", axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left + 5)
            .attr('x', 0 - (chart.height / 3))
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.y1AxisDisplayName)

        if (gridflag == true) {
            // add the X gridlines
            /*  svg.append("g")
                  .attr("class", "grid")
                  .attr("transform", "translate(0," + chart.height + ")")
                  .call(make_x_gridlines(x1Scale)
                      .tickSize(-chart.height)
                      .tickFormat("") )*/

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1AxisLabel)
                    .tickSize(-chart.width)
                    .tickFormat(""))
        }
        var slice = svg.selectAll(".slice")
            .data(groupData)
            .enter()
            .append("g")
            .attr("class", "g")
            .attr('transform', d => 'translate(' + x1AxisLabel(d.key) + ',0)')

        slice.selectAll('rect')
            .data(function (d) {
                return d.values;
            })
            .enter()
            .append('rect')
            .attr('x', d => x2AxisLabel(d.dim2_name))
            .attr('y', y1AxisLabel(0))
            .attr('width', x2AxisLabel.bandwidth())
            .attr('height', chart.height - y1AxisLabel(0))
            .attr('fill', d => metric1ColorScale(d.dim2_name))
            .on("mouseover", function(d) {
                console.log(d3.event, d); // For debugging, log the event and data
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x1MetricTooltip + colonAnnotation + numberFormat(d.metric1) + "<br/>" +
                        chart.y1MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                        chart.x2MetricTooltip + colonAnnotation + d.dim2_name
                });
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            })
            .on('contextmenu', function(d) {

                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name],  // e.g., "2019", "2020"
                    [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [d.dim2_name]               // e.g., "metric1"
                };
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            });

        slice.selectAll("rect")
            .transition()
            .delay(function () {
                return Math.random() * 1000;
            })
            .duration(1000)
            .attr("y", function (d) {
                return y1AxisLabel(d.metric1);
            })
            .attr("height", function (d) {
                return chart.height - y1AxisLabel(d.metric1);
            });

        var y1legend = svg.selectAll(".legend")
            .data(groupData[0].values.map(function (d) {
                return d.dim2_name;
            }))
            .enter().append('g')
            .attr("class", "legend")
            .attr('text-anchor', 'end')
            //.selectAll('g')
            .attr('transform', (d, i) => 'translate(0,' + i * 20 + ')')

        y1legend.append('rect')
            .attr('x', chart.width+20)
            .attr('width', 10)
            .attr('height', 10)
            .attr('fill', metric1ColorScale)

        y1legend.append('text')
            .attr('x', chart.width+70)
            .attr('y', 6)
            .attr('dy', '0.32em')
            .text(d => d[0].toUpperCase() + d.slice(1).replace(/([A-Z])/g, '$1'))
    // })
}
